import { createSelector } from 'reselect'
import * as R from 'ramda'

import { boardSettingsSelector } from './board'

// MISC

export const nudgeSettingsSelector = createSelector(
  boardSettingsSelector,
  R.propOr({}, ':board-settings/nudge-settings')
)
